const APPLY_SUMMARY_RE = /<<APPLY_SUMMARY>>\s*([\s\S]*?)\s*<<\/APPLY_SUMMARY>>/;
const APPLY_SUMMARY_OPEN = "<<APPLY_SUMMARY>>";

export function parseApplySummary(text: string): { display: string; summary: string | null } {
  const match = text.match(APPLY_SUMMARY_RE);
  if (!match) return { display: text.trim(), summary: null };
  return {
    display: text.replace(APPLY_SUMMARY_RE, "").trim(),
    summary: match[1].replace(/<[^>]*>/g, "").trim() || null,
  };
}

/** Hide a half-written apply block while tokens are still arriving. */
export function displayStreamingText(text: string): string {
  const parsed = parseApplySummary(text);
  if (parsed.summary) return parsed.display;
  const cut = text.indexOf(APPLY_SUMMARY_OPEN);
  return (cut === -1 ? text : text.slice(0, cut)).trim();
}
